module.exports = __webpack_public_path__ + "img/publish-icon.fbcdab35.png";